import { render, staticRenderFns } from "./emolumentoTurmaPdf.vue?vue&type=template&id=23824016&scoped=true&"
import script from "./emolumentoTurmaPdf.vue?vue&type=script&lang=js&"
export * from "./emolumentoTurmaPdf.vue?vue&type=script&lang=js&"
import style0 from "./emolumentoTurmaPdf.vue?vue&type=style&index=0&id=23824016&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23824016",
  null
  
)

export default component.exports